import api from './api';

/**
 * Collegamento del braccialetto Polar al paziente.
 *
 * `mioAccesso` non e' una comodita' per nascondere la linguetta: e' il
 * server che dice se chi guarda ha la casella «percorso longevity». Il
 * filtro vero resta comunque su ogni rotta - nascondere una voce di menu
 * non protegge niente.
 */
export const polarAPI = {
    mioAccesso: () => api.get('/polar/mio-accesso'),
    stato: (pazienteId) => api.get(`/polar/paziente/${pazienteId}`),
    link: (pazienteId) => api.post(`/polar/paziente/${pazienteId}/link`),
    sincronizza: (pazienteId) => api.post(`/polar/paziente/${pazienteId}/sincronizza`),
    scollega: (pazienteId) => api.delete(`/polar/paziente/${pazienteId}`),
};

export default polarAPI;
